module.exports = __webpack_public_path__ + "static/media/trabajo.e648af77.svg";